module.exports = __webpack_public_path__ + "static/w3-datepicker-basic-b4ffdccb0a56b12228be53f6e141e212.png";